import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@material-ui/core"
import styled from "styled-components"
import colors from "theme/colors"
import { SharedHoldersChartDataProps } from "./SharedHoldersChart"

const StyledTableContainer = styled(TableContainer)`
  width: 328px;
  border: 1px solid ${colors.activitiesBorder};
  padding: 0 11px;
  margin-bottom: 11px;

  .MuiTableRow-root:last-of-type {
    th,
    td {
      border: none;
    }
  }
`

const StyleTableCell = styled(TableCell)<{ $isValue?: boolean }>`
  padding: 12px 0;
  color: ${(p) => (p.$isValue ? colors.black : colors.gray)};
  font-size: 12px;
`

const ShareHoldersTable = ({
  dataSharedHolders,
}: SharedHoldersChartDataProps) => {
  return (
    <div>
      <StyledTableContainer>
        <Table role="presentation">
          <TableBody>
            {dataSharedHolders?.map((row, i) => (
              <TableRow key={i}>
                <StyleTableCell component="th" scope="row">
                  {row.shareholderName?.value}
                </StyleTableCell>
                <StyleTableCell $isValue align="right">
                  {row.sharePercentage?.value}%
                </StyleTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </div>
  )
}

export default ShareHoldersTable
